"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DateNavigation = _interopRequireDefault(require("./../navigations/DateNavigation"));
var _ScheduleList = _interopRequireDefault(require("./../lists/ScheduleList"));
var _dateHelpers = require("../../utils/date-helpers");
var _format = _interopRequireDefault(require("date-fns/format"));
var _sub = _interopRequireDefault(require("date-fns/sub"));
function ScheduleLayout(_ref) {
  let {
    schedule = [],
    handleScheduleClicks = () => true,
    handleDateChanged = () => true
  } = _ref;
  const estDateString = new Date().toLocaleString('en-US', {
    timeZone: "America/New_York"
  });
  const estDate = new Date(estDateString);
  const [currentDate, setCurrentDate] = (0, _react.useState)(Number.parseInt((0, _format.default)(estDate, 'H'), 10) < 6 ? (0, _sub.default)(estDate, {
    days: 1
  }) : estDate);
  const weeks = (0, _dateHelpers.create2WeeksList)();
  const [isFetching, setIsFetching] = (0, _react.useState)(false);
  const [exiting, setExiting] = (0, _react.useState)(false);
  const defaultHandleDateChanged = date => {
    setExiting(true);
    setTimeout(() => {
      setIsFetching(true);
    }, 325);
    setTimeout(() => {
      setCurrentDate(date);
      handleDateChanged(date);
    }, 2000);
  };
  (0, _react.useEffect)(() => {
    setExiting(false);
    setIsFetching(false);
  }, [schedule]);
  (0, _react.useEffect)(() => {
    handleScheduleClicks(currentDate);
  }, [currentDate, handleScheduleClicks]);
  return /*#__PURE__*/_react.default.createElement("schedule-layout", null, /*#__PURE__*/_react.default.createElement(_DateNavigation.default, {
    weeks: weeks,
    handleDateChanged: defaultHandleDateChanged
  }), /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _format.default)(currentDate, 'yyyy-MM-dd'),
    role: "tabpanel"
  }, /*#__PURE__*/_react.default.createElement(_ScheduleList.default, {
    schedule: schedule,
    handleClicks: handleScheduleClicks,
    fetching: isFetching,
    exiting: exiting
  })));
}
var _default = exports.default = ScheduleLayout;